import React from 'react';

/** Route-level Suspense fallback. */
export default function Loading() {
    return (
        <div className="loader" role="status" aria-live="polite">
            <span className="loader__ring" aria-hidden="true" />
            <span className="visually-hidden">Loading</span>
        </div>
    );
}
